import { useState } from "react";
import { Modal } from "react-bootstrap";
import ToggleSwitch from "./Util/ToggleSwitch";

const ManageOrgModal = (props) => {
    const [org, setOrg] = useState(props.orgToEdit ?? {
        name: '', 
        description: '',
        settings: {
            hideAnnotations: true,
            hideTimelineViews: true
        }
    });

    const saveOrgDetails = () => {
        props.saveOrgDetails(org);
    }

    return (
        <Modal
            show={() => props.setShowManageOrgModal(true)}
            onHide={() => props.setShowManageOrgModal(false)}
            backdrop="static"
            keyboard={false}
            size='md'
            dialogClassName="manage-org-modal-dialog"
            className="manage-org-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>{`${props.orgToEdit ? 'Edit' : 'Create'} Organization`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="manage-org-form-body">
                    <div className="form-group">
                        <label className="form-label" htmlFor="manage-org-name">Organization Name</label>
                        <input type="text" className="form-control" value={org.name} onInput={e => setOrg({ ...org, name: e.target.value })}/>
                    </div>
                    
                    <div className="form-group">
                        <label className="form-label" htmlFor="manage-org-name">Description</label>
                        <input type="text" className="form-control" value={org.description} onInput={e => setOrg({ ...org, description: e.target.value })}/>
                    </div>

                    <div className="form-group">
                        <ToggleSwitch checked={org.settings?.hideAnnotations ?? false} onChange={(e) => setOrg({...org, settings: {...org.settings, hideAnnotations: !org.settings.hideAnnotations}})} label={"Hide Annotations"} />
                    </div>
                    <div className="form-group">
                        <ToggleSwitch checked={org.settings?.hideTimelineViews ?? false} onChange={(e) => setOrg({...org, settings: {...org.settings, hideTimelineViews: !org.settings.hideTimelineViews}})} label={"Hide Timeline Views"} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="btn-area">
                    <a onClick={() => props.setShowManageOrgModal(false)} className="btn btn-text">Cancel</a>
                    <button type="button" className="btn btn-primary" aria-label="Submit" onClick={saveOrgDetails}>
                        {`${props.orgToEdit ? 'Save' : 'Create'}`}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    ); 
}

export default ManageOrgModal;